// src/components/pages/EmpresaNoDisponible.tsx
//
// Página pública que se muestra cuando se intenta ver/reservar en una
// empresa que no tiene plan efectivo activo (ni promo ni contratado).
// Pensada para visitantes sin cuenta (llegan por enlace o buscador), así
// que no redirige a login: informa y ofrece volver al inicio / explorar.

import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CalendarOff, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function EmpresaNoDisponible() {
  const navigate = useNavigate();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#f4f6f9] dark:bg-black px-6 font-sans">
      {/* Fondo con resplandores, mismo lenguaje visual que el resto de la app */}
      <div
        className="absolute inset-0 dark:hidden"
        style={{
          background: `
            radial-gradient(ellipse at 20% 25%, rgba(40,142,127,0.16) 0%, transparent 55%),
            radial-gradient(ellipse at 80% 75%, rgba(26,77,122,0.18) 0%, transparent 55%)
          `,
        }}
      />
      <div
        className="absolute inset-0 hidden dark:block"
        style={{
          background: `
            radial-gradient(ellipse at 20% 25%, rgba(40,142,127,0.14) 0%, transparent 55%),
            radial-gradient(ellipse at 80% 75%, rgba(16,50,84,0.35) 0%, transparent 55%)
          `,
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45 }}
        className="relative z-10 flex w-full max-w-md flex-col items-center rounded-3xl border border-[#e6eaf0] bg-white/80 p-10 text-center shadow-[0_20px_60px_-30px_rgba(16,50,84,0.4)] backdrop-blur-sm dark:border-white/10 dark:bg-white/5"
      >
        <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#eef0f5] dark:bg-white/10">
          <CalendarOff className="h-7 w-7 text-[#103254] dark:text-[#9db4cc]" />
        </div>

        <h1 className="mb-2 text-2xl font-extrabold tracking-tight text-[#0f1e2e] dark:text-white">
          Esta página no está disponible
        </h1>

        <p className="mb-8 max-w-sm text-[15px] leading-relaxed text-gray-500 dark:text-gray-400">
          El negocio que buscas no está aceptando reservas en este momento.
          Puede que vuelva a estar disponible más adelante.
        </p>

        <div className="flex w-full flex-col gap-2 sm:flex-row">
          <Button
            variant="outline"
            onClick={() => navigate('/')}
            className="flex-1 rounded-xl py-3 font-semibold dark:bg-white/5 dark:border-white/10 dark:text-white"
          >
            <Home className="mr-2 h-4 w-4" />
            Ir al inicio
          </Button>
        </div>
      </motion.div>
    </div>
  );
}